<template>
  <div class="order_import">
    <div class="order_import_top">订单导入</div>
    <div class="order_import_tips">
      <p>操作提示信息：</p>
      <!--<p>1.请严格根据 “<i class="fcBlue">订单导入模板文件.xlsx</i>”的格式要求进行数据录入才进行导入；</p>-->
      <p>1.请严格根据 “订单导入模板文件.xlsx”的格式要求进行数据录入才进行导入；</p>
      <p>2.导入订单的生成将根据导入文件中渠道和订单编号组合，相同的作为一笔订单进行生成；</p>
      <p>3.订单导入后，相同订单号有多行明细的，订单的收货信息数据和买家留言数据等共性信息只会取第一行数据记录进系统；</p>
      <p>4.成功导入的订单，订单状态将会跳过审核直接进入到待付款状态；</p>
      <p>5.订单所指定的渠道如果不是已绑定供应商的自营仓，订单导入后不会锁定库存，订单需要完成付款后才会锁定库存，导入完订单后请尽快到订单列表中完成付款操作。</p>
    </div>
    <div class="mb10 ml20">
      <button class="btn_normal" @click="getOrderImportExcelTemplet()">下载导入模板</button>
    </div>
    <div class="mb10 ml20">
      <span>选择上传的文件：</span>
      <input id="import_file" type="file" @change="tirggerFile($event)" accept=".xls,.xlsx">
      <button class="btn_normal" @click="importOrderExcel()">开始导入</button>
    </div>

    <!--弹出框-->
    <order-import-embed-msg v-if="isShow"
                            :title="dialogTitle"
                            :msg="msg"
                            :errorTxt="errorTxt" @cancelbtn="getSelectDialogEmbed"></order-import-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import OrderImportEmbedMsg from './order-import-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'order-import',
    components: {LoadingDialog, MsgDialog, OrderImportEmbedMsg},
    data() {
      return {
        importFile: null,
        uploadMsg: null, // 上传结果信息
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        msg: null, // 弹出框传入内容
        dialogTitle: null, // 弹出框头部名
        errorTxt: null, // 弹出框错误信息提示
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取订单导入模板
      getOrderImportExcelTemplet() {
        this.$axios.get(this.Global.getOrderImportExcelTemplet).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
        console.log(222, e);
        console.log(333, this.importFile);
      },

      // 订单导入
      importOrderExcel() {
        console.log(111, this.importFile);
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        // const formData = new window.FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importOrderExcel, formData).then((res) => {
          document.getElementById('import_file').value="";  // 清空上传的文件：解决—订单导入这个的功能，选择的上传文件如果发生变更，点击开始导入  会没响应，经常会出现导入报错后，用户手动直接重新修改导入文件保存就点击导入没反应。
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            console.log(444, res);
            if (res) {
              if (res.data.errorMsg.length && !res.data.resData) {
                self.uploadMsg = res.data.resData;
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
              if (res.data.resData) {
                self.isShow = true;
                self.errorTxt = res.data.errorMsg;
                self.msg = res.data.resData;
                self.dialogTitle = '错误提示';
              }
            }
          }, 500);
        });
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";

  .order_import {
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: $cfff;

    .order_import_top {
      font-size: 18px;
      color: #000;
      height: 40px;
      line-height: 40px;
      width: 200px;
      background: #f1f1f1;
      border-radius: 10px 10px;
      text-align: center;
      letter-spacing: 10px;
      margin: 20px 50px;
    }

    .order_import_tips {
      border: 1px solid #9a8f8f;
      margin: 0 20px 10px;
      padding: 5px;
      width: 700px;
      min-height: 150px;

      p {
        line-height: 21px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/order-import.vue